import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
import notiAlert from "@frameworks/web/assets/images/features/TOC/Common/notification.svg";
import { useNavigate } from "react-router-dom";
var NotificationMessage = function (props) {
    var navigate = useNavigate();
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "notificationbox ".concat(props.parentclass), style: {
                    backgroundColor: props.backColor,
                    borderColor: props.borderColor,
                } },
                React.createElement("div", { className: "notit-ls" },
                    props.notiiconAlert ? React.createElement("img", { src: notiAlert }) : null,
                    props.prefredIcon ? (React.createElement("i", { className: "edel-icon-flash txt-orange-light " })) : null),
                React.createElement("div", { className: "notit-rs" },
                    React.createElement("h1", { className: "DMSanM_14_500 txt_blackOne1" }, props.notiHeading),
                    React.createElement("p", { className: "DMSanN_12_400 txt_primaryGrey" }, props.DescriptionTop),
                    props.ShowlinkValue ? (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: props.linkValue, onClick: function () {
                            window.open("https://www.nuvamawealth.com/nav-applicability-norms-in-mf", "_blank");
                        } })) : null,
                    props.showDescriptionBottom ? (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "DMSanN_12_400 txt_primaryGrey mt-3" }, props.DescriptionBottom))) : null)))));
};
export default NotificationMessage;
